/** True for iPhone / iPad / iPod / Mac (incl. iPadOS desktop UA). */
export function isApplePlatform(): boolean {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent || '';
  const platform =
    // navigator.userAgentData is Chromium; fall back to classic fields
    (navigator as Navigator & { userAgentData?: { platform?: string } })
      .userAgentData?.platform ||
    navigator.platform ||
    '';

  if (/iPhone|iPad|iPod/i.test(ua)) return true;

  // iPadOS 13+ can report as Macintosh with touch
  if (
    /Mac/i.test(platform) &&
    typeof navigator.maxTouchPoints === 'number' &&
    navigator.maxTouchPoints > 1
  ) {
    return true;
  }

  if (/Macintosh|Mac OS X|MacIntel|MacPPC|Mac68K/i.test(ua + platform)) {
    return true;
  }

  return false;
}
